import closest from 'closest';
import isDom from 'is-dom';
import template from 'lodash/template';
import to_array from 'to_array';
import domify from 'domify';
import Alert from '../functions/GlobalAlerts';
import moneyToFloat from '../functions/moneyToFloat';
import makeSelectizeOnEach from '../functions/makeSelectizeOnEach';
import Approver from './components/Approver';
import FluxStep from './components/FluxStep';
import AdditionalFluxStep from './components/AdditionalFluxStep';
import FluxosDeAprovacao from '../api/FluxosDeAprovacao';
import Group from './components/Group';
import times from 'lodash/times';
import hasDuplicated from '../functions/hasDuplicated';
import _isNaN from 'lodash/isNaN';
import isMoney from '../functions/isMoney';
import GlobalAlerts from '../functions/GlobalAlerts';
const Lang = require('lang');

class ApprovalFlux {
  /**
   * @prop {RegExp}
   */
  static url = /^\/settings\/fluxos-aprovacao\/(create|\d+\/edit)$/;

  constructor() {
    nifty.body.overlay({
      fixed: true
    });

    this.editing = false;
    this.removeStepButtonClickHandler = this.removeStepButtonClickHandler.bind(this);
    this.conditionChangeHandler = this.conditionChangeHandler.bind(this);
    this.addApproverClickHandler = this.addApproverClickHandler.bind(this);
    this.addStepButtonClickHandler = this.addStepButtonClickHandler.bind(this);
    this.addGroupClickHandler = this.addGroupClickHandler.bind(this);
    this.removeButtonClickHandler = this.removeButtonClickHandler.bind(this);
    this.duplicatedUserValidation = this.duplicatedUserValidation.bind(this);
    this.stepObligatoryChangeHandler = this.stepObligatoryChangeHandler.bind(this);
    this.conditionValueChangeHandler = this.conditionValueChangeHandler.bind(this);
    this.renderFromApi = this.renderFromApi.bind(this);
    this.idAprovacaoFluxo = document.getElementById('idAprovacaoFluxo');
    this.descricaoInput = document.getElementById('descricao');
    this.stepTemplate = new FluxStep;
    this.additionalStepTemplate = new AdditionalFluxStep;
    this.groupTemplate = new Group;
    this.approverTemplate = new Approver;

    this.validationErrorDescricao = domify(
      '<p class="help-block">' + Lang.get('js/src/classes/ApprovalFlux.description_cannot_be_empty') + '</p>'
    );

    this.validationErrorValorEtapa = domify(
      `<p class="help-block">
        ` + Lang.get('js/src/classes/ApprovalFlux.field_required_numbers_dots') + `
      </p>`
    );

    this.$wizard = this.createWizard();


    document.body
      .addEventListener('change', this.conditionChangeHandler, true);
    document.body
      .addEventListener('change', this.stepObligatoryChangeHandler, true);
    document.body
      .addEventListener('blur', this.conditionValueChangeHandler, true);
    document.body
      .addEventListener('change', this.stepStartValueChangeHandler, false);
    document.body
      .addEventListener('change', this.duplicatedUserValidation, true);
    document.body
      .addEventListener('click', this.addStepButtonClickHandler, false);
    document.body
      .addEventListener('click', this.addApproverClickHandler, false);
    document.body
      .addEventListener('click', this.addGroupClickHandler, false);
    document.body
      .addEventListener('click', this.removeStepButtonClickHandler, false);
    document.body
      .addEventListener('click', this.removeButtonClickHandler, false);

    nifty.body.overlay('show')

    if (this.idAprovacaoFluxo) {
      this.editing = true;
      FluxosDeAprovacao.show(this.idAprovacaoFluxo.value)
        .then(this.renderFromApi)
        .then(() => nifty.body.overlay('hide'))
        .catch((e) => {
          GlobalAlerts.createAndShow({
            type: 'danger',
            title: Lang.get('js/common/phrases.ops'),
            message: Lang.get('js/common/phrases.unexpected_error'),
          })
        });
    } else {
      // Create the first step
      document.querySelector('.js-add-etapa').click();
      this.createButtonAddStep();
      nifty.body.overlay('hide')
    }

    this.adjustRemoveButtons().adjustNavigationButtons();
  }

  static init() {
    window.flux = new ApprovalFlux();
    return window.flux;
  }

  /**
   * Remove a etapa adicional e habilita as outras etapas
   */
  removeAdditionalStep() {
    const wizards = $('[id^="wizard-t-"]');
    const removeButtons = $('.wizard-remove-step');
    const addButton = $('.js-add-etapa ');

    wizards.removeClass('disabled');
    removeButtons.removeClass('disabled');
    addButton.removeClass('disabled');
  }

  /**
   * Valida se precisa criar uma etapa adicional e cria ela
   */
  validateAndCreateAdditionalStep() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('editar-fluxo-etapa-adicional')) {
      if (params.get('editar-fluxo-etapa-adicional') == 1) {
        this.createAdditionalStep();
      }
    }
  }

  /**
   * Cria a etapa adicional e desabilita as outras
   */
  createAdditionalStepApi() {
    const self = this;

    bootbox.confirm({
      size: 'medium',
      buttons: {
        confirm: {
          label: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_confirm'),
          className: 'btn btn-success'
        },
        cancel: {
          label: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_cancel'),
          className: 'btn btn-default'
        }
      },
      title: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_title'),
      message: `
      <div>
        <p> ${Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_message')} </p>
        <strong> <i class="fa fa-warning mr-2" style="color: orange;"> </i> ${Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_warning')} </strong>
      </div>
      `,
      callback: function (result) {
        if (!!result) {
          return self.createAdditionalStep(true);
        }

        self.save(true);
      }
    });
  }

  /**
   * Cria a etapa adicional e desabilita as outras
   */
  createAdditionalStep() {
    const wizards = $('[id^="wizard-t-"]');
    const removeButtons = $('.wizard-remove-step');
    const addButton = $('.js-add-etapa ');

    const etapa = {
      id: String(Number(new Date))
    };

    const stepElement = this.additionalStepTemplate.render({
      etapa
    });

    this.$wizard.steps('add', {
      title: Lang.get('js/src/classes/ApprovalFlux.approval_step'),
      content: stepElement
    });

    this.adjustmentAlignSteps();

    stepElement
    .querySelector('.js-add-grupo')
    .click();

    times(wizards.length, () => this.$wizard.steps('next'));

    wizards.addClass('disabled');
    removeButtons.addClass('disabled');
    addButton.addClass('disabled');

    this.adjustRemoveButtons();
  }

  validateAndShowModalCreateAdditionStep() {
    const exibeModal = $('#exibe-modal-criar-etapa-adicional');
    const form = $('#centro-custos-vinculados').find('form');
    const self = this;

    function serializeArrayToJson(formSerializeArr) {
      const jsonObj = {};
      jQuery.map( formSerializeArr, function( n, i ) {
        if (n.name.includes('[]')) {
          jsonObj[n.name] = Array.isArray(jsonObj[n.name]) ? [...jsonObj[n.name], n.value] : [n.value];
        } else {
          jsonObj[n.name] = n.value;
        }
      });

      return jsonObj;
    }

    if (exibeModal.data('exibe-modal-etapa-adicional') == '1') {
      bootbox.confirm({
        size: 'medium',
        buttons: {
          confirm: {
            label: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_confirm'),
            className: 'btn btn-success'
          },
          cancel: {
            label: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_cancel'),
            className: 'btn btn-default'
          }
        },
        title: Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_title'),
        message: `
        <div>
          <p> ${Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_message')} </p>
          <strong> <i class="fa fa-warning mr-2" style="color: orange;"> </i> ${Lang.get('js/src/classes/ApprovalFlux.cost_center_same_approver_warning')} </strong>
        </div>
        `,
        callback: function (result) {
          const data = serializeArrayToJson(jQuery(form).serializeArray());
          const hash = !!result ? '?&editar-fluxo-etapa-adicional=1' : false;

          data['confirmacaoCriarEtapaAdicional'] = !!result;
          data['_method'] = 'POST';

          const request = $.ajax({
            method: 'POST',
            url: form.attr('action'),
            data
          });

          request
          .then(() => {
            self.notifySuccessCreateFlux(hash);
          }).catch(() => {
            Alert.createAndShow({
              title: Lang.get('js/src/classes/ApprovalFlux.issue_happened'),
              message: Lang.get('js/src/classes/ApprovalFlux.not_able_to_save_from_approval_flow') + ' <strong>VEXPENSES</strong>',
              type: 'danger'
            });
          });
        }
      });
    }
  }

  renderFromApi(etapas) {
    let disableAddButton = false;

    etapas.forEach((etapa, n) => {
      etapa.id = String(Number(new Date) + n * 1000);
      let stepElement = this.stepTemplate.render({
        etapa
      });

      if (etapa.etapaObrigatoriaMesmoAprovador) {
        const wizards = $('[id^="wizard-t-"]');
        const removeButtons = $('.wizard-remove-step');

        stepElement = this.additionalStepTemplate.render({
          etapa
        });

        wizards.addClass('disabled');
        removeButtons.addClass('disabled');
        disableAddButton = true;
      }

      this.$wizard.steps('add', {
        title: Lang.get('js/src/classes/ApprovalFlux.approval_step'),
        content: stepElement
      });

      const valorInput = document
        .querySelector(`[name="valorCondicao[${etapa.id}]"]`);

      if (valorInput) {
        valorInput.value = Number(etapa.valorEntradaEtapa);
        valorInput.dispatchEvent(new Event('blur'));
      }

      const groupContainer = this.getGroupContainer(etapa);
      let counterGroup = 1;

      etapa.filhas.forEach((grupo, n) => {
        grupo.id = String(Number(new Date) + n * 1000);
        grupo.number = counterGroup;
        counterGroup++;

        const groupElement = this.groupTemplate.render({
          etapa,
          grupo
        });

        groupContainer.appendChild(groupElement);

        const userContainer = this.getApproverContainer(grupo);

        grupo.filhas.forEach((aprovador, n) => {
          aprovador.id = String(Number(new Date) + n * 1000);
          const approverElement = this.approverTemplate.render({
            aprovador,
            grupo,
            etapa,
            value: aprovador.idUsuarioAprovador
          });

          userContainer.appendChild(approverElement);

        });

        const condicaoNeto = groupElement.querySelector('[name^="condicaoNeto["]')
        condicaoNeto.value = grupo.condicaoFilho;
        condicaoNeto.dispatchEvent(new Event('change'));
      });

      const condicaoFilho = stepElement.querySelector('[name^="condicaoFilho["]')
      condicaoFilho.value = etapa.condicaoFilho;
      condicaoFilho.dispatchEvent(new Event('change'));

      this.adjustGroupNumbers(etapa.id);
    });

    this.createButtonAddStep();
    this.adjustmentAlignSteps();

    this.adjustRemoveButtons();

    const lastStepWizard = $(`[id="wizard-t-${etapas[etapas.length - 1].ordem - 1}"]`);
    const addButton = $('.btn-add-step.js-add-etapa');

    lastStepWizard && lastStepWizard.trigger('click');

    disableAddButton && addButton.addClass('disabled');

    this.validateAndShowModalCreateAdditionStep();
    this.validateAndCreateAdditionalStep();

    makeSelectizeOnEach('[data-input="selectize"]');
  }

  save(continueAnyway = false) {
    nifty.body.overlay('show');
    const additionalStep = $('[data-etapa-adicional="1"');
    const additionalStepId = additionalStep.data('etapa-id');

    const selectors = [
      'input:not(:disabled)',
      'select:not(:disabled)'
    ];

    let inputs = to_array(this.$wizard[0].querySelectorAll(selectors.join(',')));

    inputs = inputs.reduce((obj, el) => {
      if (!el.name) {
        return obj;
      }

      obj[el.name] = el.value;
      return obj;
    }, {});

    inputs.descricao = this.descricaoInput.value;

    if (additionalStepId) {
      inputs.etapaObrigatoriaMesmoAprovador = additionalStepId;
      inputs.confirmacaoCriarEtapaAdicional = true;
    }

    if (continueAnyway) {
      inputs.confirmacaoCriarEtapaAdicional = false;
    }

    const request = this.editing ?
      FluxosDeAprovacao.update(this.idAprovacaoFluxo.value, inputs, continueAnyway) :
      FluxosDeAprovacao.create(inputs);

    request
      .then((response) => {
        const { data } = response;

        if (
          !!data &&
          'exibeModalCriarEtapaAdicional' in data &&
          data['exibeModalCriarEtapaAdicional']
        ) {
          return this.createAdditionalStepApi();
        }

        if (window.environment !== 'production') {
          return this.notifySuccessCreateFlux();
        }

        const self = this;
        dataLayer.push({
          'event': 'novo-flx-aprov',
          'eventCallback': function () {
            dataLayer.forEach((a) => console.log(a));
            self.notifySuccessCreateFlux();
          },
          'eventTimeout': 2000
        });
      }).catch(() => {
        Alert.createAndShow({
          title: Lang.get('js/src/classes/ApprovalFlux.issue_happened'),
          message: Lang.get('js/src/classes/ApprovalFlux.not_able_to_save_from_approval_flow') + ' <strong>VEXPENSES</strong>',
          type: 'danger'
        });
      })
      .then(() => {
        nifty.body.overlay('hide');
      })
  }

  notifySuccessCreateFlux(params) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('editar-fluxo-etapa-adicional')) {
      window.history.replaceState(null, '', window.location.pathname);
    }

    Alert.create({
      title: Lang.get('js/src/classes/ApprovalFlux.success'),
      message: Lang.get('js/src/classes/ApprovalFlux.approval_flow_was') + `
        ${this.editing ? Lang.get('js/src/classes/ApprovalFlux.updated') : Lang.get('js/src/classes/ApprovalFlux.created')}
        ` + Lang.get('js/src/classes/ApprovalFlux.with_success'),
    });

    scroll(0, 0);

    const url = document.referrer !== '' && document.referrer !== window.location.href
      ? document.referrer
      : FluxosDeAprovacao.url();

    location.assign(params ? url + params : url);
  }

  getGroupContainer(etapa) {
    return document.getElementById(`grupos-${etapa.id}`);
  }

  getApproverContainer(grupo) {
    return document.getElementById(`aprovadores-${grupo.id}`);
  }

  descriptionValidation() {
    const container = closest(this.descricaoInput, '.form-group');

    if (this.descricaoInput.value.length) {
      container.classList.remove('has-error');
      this.validationErrorDescricao.remove();

      return true;
    }


    container.classList.add('has-error');
    container.appendChild(this.validationErrorDescricao);

    return false;
  }

  descriptionChangeHandler(event) {
    this.descriptionValidation();
  }

  startValueValidation() {
    const inputs = to_array(document.querySelectorAll('[name^=valorCondicao]'));

    const isValid = inputs.map(input => {
      const etapa = closest(input, '.etapa');
      const inputContainer = closest(input, '.form-group');

      if (isMoney(input.value) || !input.value.length) {
        inputContainer.classList.remove('has-error');
        const help = inputContainer.querySelector('.help-block');
        help && help.remove();

        return true;
      }

      inputContainer.classList.add('has-error');
      inputContainer.appendChild(this.validationErrorValorEtapa);

      input.select();
      input.focus();

      return false;
    }).every(isValid => isValid);

    return isValid;
  }

  stepObligatoryChangeHandler(event) {
    const input = closest(event.target, '[name^="etapaObrigatoria"]', true);

    if (input) {
      const container = closest(input, '.box__body');
      const isObligatory = Boolean(Number(input.value));
      const valorContainer = container.querySelector('.js-valor-etapa');

      if (isObligatory) {
        const valorInput = container.querySelector('[name^="valorCondicao"]');
        valorInput.value = '0.00';
      }

      valorContainer.classList.toggle('hidden', isObligatory);
    }
  }

  conditionValueChangeHandler(event) {
    const input = closest(event.target, '[name^="valorCondicao"]', true);

    if (input) {
      const container = closest(input, '.box__body');
      const select = container.querySelector('[name^="etapaObrigatoria"]');

      if (!isMoney(input.value)) {
        const inputContainer = closest(input, '.form-group');
        inputContainer.classList.add('has-error');
        inputContainer.appendChild(this.validationErrorValorEtapa);
        return true;
      }

      const value = moneyToFloat(input.value);
      const isObligatory = value < 1;
      select.value = Number(isObligatory);
      select.dispatchEvent(new Event('change'));
    }
  }

  emptyGroupsValidation() {
    const etapas = to_array(document.getElementsByClassName('js-grupo'));
    const hasNoValue = input => !input.value;

    const hasEmptyStep = etapas.reduce((hasEmptyStep, etapa) => {
      const inputs = to_array(etapa.querySelectorAll('[name^="usuarios["]'));
      return hasEmptyStep || inputs.every(hasNoValue);
    }, false);

    if (hasEmptyStep) {
      bootbox.alert({
        size: 'small',
        title: Lang.get('js/src/classes/ApprovalFlux.no_approver'),
        message: Lang.get('js/src/classes/ApprovalFlux.not_able_create_group'),
        closeButton: false
      });

      return false;
    }

    return true;
  }

  duplicatedUserValidation(event) {
    const input = closest(event.target, 'select[name^="usuarios"]', true);

    if (input) {
      const selectize = input.selectize;
      const inputs = to_array(document.querySelectorAll('select[name^="usuarios"]'));
      const usuarios = inputs.map(input => Number(input.value)).filter(Boolean);

      if (hasDuplicated(usuarios)) {
        const usuario = selectize.options[selectize.getValue()].text;

        bootbox.alert({
          title: Lang.get('js/src/classes/ApprovalFlux.user_not_allowed'),
          message: Lang.get('js/src/classes/ApprovalFlux.user_cannot_be_approver', { user: usuario }),
          size: 'small',
          closeButton: false
        });

        selectize.clear(true);
      }
    }
  }

  addStepButtonClickHandler(event) {
    const btn = closest(event.target, '.js-add-etapa', true);

    if (btn) {
      const wizards = document.querySelectorAll('[id^="wizard-t-"]');

      const etapa = {
        id: String(Number(new Date))
      };

      const stepElement = this.stepTemplate.render({
        etapa
      });

      this.$wizard.steps('add', {
        title: Lang.get('js/src/classes/ApprovalFlux.approval_step'),
        content: stepElement
      });

      this.adjustmentAlignSteps();

      stepElement
        .querySelector('.js-add-grupo')
        .click();


      times(wizards.length, () => this.$wizard.steps('next'));

      this.adjustRemoveButtons();
    }
  }

  removeButtonClickHandler(event) {
    const btn = closest(event.target, '.js-remove', true);

    if (btn) {
      const removable = closest(btn, '.js-removable');
      const container = closest(removable, '.box__body, .template-container');
      const etapa = closest(container, '.etapa');
      let count = 0;

      if (removable.classList.contains('js-grupo')) {
        count = container.getElementsByClassName('js-grupo').length;
      }

      if (removable.classList.contains('js-aprovador')) {
        count = container.getElementsByClassName('js-aprovador').length;
      }

      // Remove element if exists and is not the last
      removable && count > 1 && removable.remove();

      this.adjustGroupNumbers(etapa);
    }
  }

  addApproverClickHandler(event) {
    const btn = closest(event.target, '.js-add-aprovador', true);

    if (btn) {
      const container = closest(btn, '.box__body')
        .querySelector('.template-container');

      const etapa = {
        id: btn.dataset.etapaId
      };


      const grupo = {
        id: btn.dataset.grupoId,
      };

      const aprovador = {
        id: String(Number(new Date))
      };

      const approverElement = this.approverTemplate.render({
        etapa,
        grupo,
        aprovador,
        value: 0
      });

      container.appendChild(approverElement);

      closest(container, '.js-grupo')
        .querySelector('[name^="condicaoNeto"]')
        .dispatchEvent(new Event('change'));

      makeSelectizeOnEach('[data-input="selectize"]');
    }

    return this;
  }

  addGroupClickHandler(event) {
    const btn = closest(event.target, '.js-add-grupo', true);

    if (btn) {
      const container = closest(btn, '.etapa')
        .querySelector('.template-container');

      const numbers = String(container.querySelectorAll('.js-grupo').length);
      const numberGroup = parseInt(numbers) + 1;
      const etapa = {
        id: btn.dataset.etapaId
      };

      const grupo = {
        id: String(Number(new Date)),
        number: numberGroup
      };

      const aprovador = {
        id: String(Number(new Date))
      };

      const groupElement = this.groupTemplate.render({
        etapa,
        grupo
      });

      container.appendChild(groupElement);
      this.adjustGroupNumbers(etapa.id);

      // Add an user selector to the group container
      groupElement.querySelector('.js-add-aprovador').click();
    }

    return this;
  }

  conditionChangeHandler(event) {
    const selector = '[name^=condicaoFilho],[name^=condicaoNeto]';
    const input = closest(event.target, selector, true);

    if (input) {
      const container = closest(input, '.etapa');
      const inputs = container.querySelectorAll(`[name="${input.name}"]`);
      to_array(inputs).forEach(el => el.value = input.value);
    }
  }

  adjustGroupNumbers(etapaId) {
    const etapa = isDom(etapaId) ?
      etapaId :
      document.querySelector(`[data-etapa-id="${etapaId}"]`);

    if (etapa) {
      const groupNumbers = to_array(etapa.querySelectorAll('.group-number'));
      groupNumbers.forEach((el, i) => el.innerText = Lang.get('js/src/classes/ApprovalFlux.group') + `${i + 1}`);

      return this;
    }

    console.warn('Expected element or id but received: ' + etapa);
    return this;
  }

  adjustRemoveButtons() {
    const removeButtons = document.querySelectorAll('a > .wizard-remove-step');
    const removeButtonsToRemove = document.querySelectorAll('li > .wizard-remove-step');

    [...removeButtonsToRemove]
      .forEach(element => {
        if (closest(element, 'li').querySelector('a > .wizard-remove-step')) {
          element.parentNode.removeChild(element);
        }
      });

    [...removeButtons]
      .forEach(element => closest(element, 'li').appendChild(element));

    return this;
  }

  adjustNavigationButtons() {
    const finish = document.getElementById('finish');
    finish.addEventListener('click', () => this.finish());
  }

  removeStepButtonClickHandler(event) {
    const btn = closest(event.target, '.wizard-remove-step', true);

    if (btn) {
      event.preventDefault();
      event.stopPropagation();
      // const clickedStep = Number(btn.dataset.step) - 1;
      // const currentStep = this.$wizard.steps('getCurrentIndex');
      // const stepsCount = document.querySelectorAll('[id^="wizard-t-"]').length;

      this.confirmeRemoveSteep(btn);

      // if (_isNaN(clickedStep)) {
      //   return this;
      // }

      // if (clickedStep === currentStep) {
      //   if (clickedStep === stepsCount - 1) {
      //     this.$wizard.steps('previous');
      //   } else {
      //     this.$wizard.steps('next');
      //   }
      // }

      // this.$wizard.steps('remove', clickedStep)
      // this.adjustRemoveButtons();

    }

    return this;
  }

  showStepById(id) {
    const index = this.getIndexByStepId(id);
    const currentStep = this.getCurrentStep();

    if (currentStep === this.getStepCount() - 1 && index < this.getCurrentStep()) {
      while (index != this.getCurrentStep()) {
        this.previousStep();
      }

      return this;
    }

    if (index > this.getCurrentStep()) {
      while (index != this.getCurrentStep()) {
        this.nextStep();
      }

      return this;
    }

    // If cames here its because its already on spot
    return this;
  }

  getIndexByStepId(id) {
    const etapa = document.querySelector(`[data-etapa-id="${id}"]`);
    const body = closest(etapa, '.body');

    // Get only the index (the only number on the id)
    const index = body.id.match(/\d+/);
    return index ? Number(index[0]) : 0;
  }

  getStepCount() {
    return document.querySelectorAll('[id^="wizard-t-"]').length;
  }

  getCurrentStep() {
    return this.$wizard.steps('getCurrentIndex');
  }

  finish() {
    if (
      this.emptyGroupsValidation() &&
      this.descriptionValidation() &&
      this.startValueValidation()
    ) {
      this.save();
    }
  }

  createWizard() {
    const _this = this;

    return $('#wizard').steps({
      headerTag: 'h3',
      bodyTag: 'div',
      transitionEffect: 0,
      cssClass: 'wizard',
      autoFocus: true,
      enableAllSteps: true,
      showFinishButtonAlways: true,
      titleTemplate: `
        <span class="number-step">#index#</span>
        <button data-step="#index#" class="wizard-remove-step"></button>
      `,
      labels: {
        cancel: Lang.get('js/src/classes/ApprovalFlux.cancel'),
        current: Lang.get('js/src/classes/ApprovalFlux.current_step'),
        pagination: Lang.get('js/src/classes/ApprovalFlux.pages'),
        finish: Lang.get('js/src/classes/ApprovalFlux.finalize'),
        next: '',
        previous: '',
        loading: Lang.get('js/src/classes/ApprovalFlux.loading')
      },
      onFinished() {
        _this.finish();
      },
    });
  }

  createButtonAddStep() {
    const list = document.querySelector('#wizard > .steps >  ul');
    const item = document.createElement('li');
    const button = document.createElement('a');
    const label = document.createElement('span');

    item.className = 'btn-add-step js-add-etapa';
    label.className = 'label-add-step';
    button.innerHTML = '+';
    label.innerHTML = Lang.get('js/src/classes/ApprovalFlux.add_steep');

    button.appendChild(label);
    item.appendChild(button);
    list.appendChild(item);
  }

  adjustmentAlignSteps() {
    const steps = document.querySelectorAll('#wizard > .steps >  ul > li');
    const list = document.querySelector('#wizard > .steps >  ul');

    if (steps.length < 5) {
      list.classList.add('list-align-center');
    } else {
      list.classList.remove('list-align-center');
    }
  }

  confirmeRemoveSteep(btn) {
    const self = this;

    bootbox.confirm({
      size: 'small',
      buttons: {
        confirm: {
          label: 'Remover',
          className: 'btn btn-danger'
        },
        cancel: {
          label: 'Cancelar',
          className: 'btn btn-default'
        }
      },
      title: Lang.get('js/src/classes/ApprovalFlux.title_confirm_remove_steep'),
      message: Lang.get('js/src/classes/ApprovalFlux.confirm_remove_steep'),
      callback: function (result) {
        self.removeSteepConfirmed(result, btn);
      }
    });
  }

  removeSteepConfirmed(result, btn) {
    const clickedStep = Number(btn.dataset.step) - 1;
    const currentStep = this.$wizard.steps('getCurrentIndex');
    const stepsCount = document.querySelectorAll('[id^="wizard-t-"]').length;
    const aditionalStep = $(`#wizard-p-${clickedStep} .etapa`).data('etapa-adicional') == '1';

    if (result === true) {

      if (_isNaN(clickedStep)) {
        return this;
      }

      if (clickedStep === currentStep) {
        if (clickedStep === stepsCount - 1) {
          this.$wizard.steps('previous');
        } else {
          this.$wizard.steps('next');
        }
      }

      this.$wizard.steps('remove', clickedStep)
      this.adjustRemoveButtons();

      if (aditionalStep) {
        this.removeAdditionalStep();
      }
    }

  }
}

export default ApprovalFlux;

